import * as React from "react";
import { getUniqueKey } from "src/business/getUniqueKey";

import { ZCatalogTreeItem } from "../ZCatalogTreeItem";

type ReactNode = React.ReactNode;

type Unassigned = "NA";
export const unassigned: Unassigned = "NA"; // Ключ "" используется для спецузла "Не назначено". Предполагается, что он только один

export type CatalogTreeNode = {
  readonly key: Unassigned | string;
  readonly name: string;
  readonly title: ReactNode;
  readonly isLeaf: boolean;
  readonly id: string;
  children?: CatalogTreeNode[];
};

export const makeCatalogTreeNodes = (
  items: ZCatalogTreeItem[],
): CatalogTreeNode[] =>
  items.map(({ id, name, hasChildren, childrenCount, cardCount }) => ({
    id: id ?? unassigned,
    key: getUniqueKey(id ?? unassigned),
    name,
    get title() {
      const text = `${name} (${childrenCount}/${cardCount})`;
      return id ? <span title={id}>{text}</span> : <b>{text}</b>;
    },
    isLeaf: !hasChildren,
  }));

export const appendCatalogTreeBranch = (
  root: CatalogTreeNode[],
  nodeKey: Unassigned | string,
  branch: ZCatalogTreeItem[],
) => {
  const node = findCatalogTreeNode(root, nodeKey);
  if (node) {
    node.children = makeCatalogTreeNodes(branch);
  }
};

export const findCatalogTreeNode = (
  nodes: CatalogTreeNode[],
  needKey: Unassigned | string,
): CatalogTreeNode | undefined => {
  // eslint-disable-next-line no-restricted-syntax
  for (const node of nodes) {
    if (node.key === needKey) return node;
    if (node.children) {
      const subNode = findCatalogTreeNode(node.children, needKey);
      if (subNode) return subNode;
    }
  }
  return undefined;
};
